// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b570f3ea","239":"bfed515c","732":"c3c31ec3"}[chunkId] + ".chunk.js";
};